import { useMemo } from 'react';

import { LAYOUT_CONFIG, getAppBarStyle, getContextPanelStyle } from '@/theme/layoutConstants';

import { useResponsiveLayout } from './useResponsiveLayout';

export const useLayoutCalculations = () => {
  const { appBarPosition, contextPanelVariant, isNarrowScreen } = useResponsiveLayout();

  const appBarHeight = isNarrowScreen
    ? LAYOUT_CONFIG.appBar.height.mobile
    : LAYOUT_CONFIG.appBar.height.desktop;

  const contextPanelHeight = LAYOUT_CONFIG.contextPanel.height;
  const contextPanelWidth = LAYOUT_CONFIG.contextPanel.width;

  // Calculate total header space for content padding
  const totalHeaderSpace = useMemo(() => {
    if (contextPanelVariant === 'toolbar' && appBarPosition === 'top') {
      return appBarHeight + contextPanelHeight;
    }
    return appBarHeight;
  }, [appBarPosition, contextPanelVariant, appBarHeight, contextPanelHeight]);

  const totalFooterSpace = useMemo(() => {
    if (contextPanelVariant === 'toolbar' && appBarPosition === 'bottom') {
      return appBarHeight + contextPanelHeight;
    }
    return appBarHeight;
  }, [appBarPosition, contextPanelVariant, appBarHeight, contextPanelHeight]);

  // Calculate sidebar space for content margin
  const sidebarSpace = useMemo(() => {
    if (contextPanelVariant === 'sidebar') {
      return contextPanelWidth;
    }
    return 0;
  }, [contextPanelVariant, contextPanelWidth]);

  return {
    appBarHeight,
    contextPanelHeight,
    contextPanelWidth,
    totalHeaderSpace,
    totalFooterSpace,
    sidebarSpace,
    appBarStyle: getAppBarStyle(appBarPosition, isNarrowScreen),
    contextPanelStyle: getContextPanelStyle(appBarPosition, contextPanelVariant, isNarrowScreen),
    // Useful derived values
    isContextPanelVisible: true, // Context panel is always visible in current design
    isContextPanelAtTop: contextPanelVariant === 'toolbar' && appBarPosition === 'top',
    isContextPanelAtBottom: contextPanelVariant === 'toolbar' && appBarPosition === 'bottom',
    isContextPanelSidebar: contextPanelVariant === 'sidebar',
  };
};
